import Html5TvPreview from "./Html5TvPreview";

interface IProps {
  productParams: any;
  setClickedCatFbsCb: any;
  ClickedCatFbsVal: any;
  setClickedCat: any;
  ClickedCat: any;
  technology: any;
  generalPreviewRef: any;
  feedbackPreviewRef: any;
  widgetCodePreviewRef: any;
}

const Html5Tv = ({
  productParams,
  setClickedCatFbsCb,
  ClickedCatFbsVal,
  setClickedCat,
  ClickedCat,
  technology,
  generalPreviewRef,
  feedbackPreviewRef,
  widgetCodePreviewRef,
}: IProps) => {
  return (
    <>
      <Html5TvPreview
        page={1}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
      />
      <Html5TvPreview
        page={2}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
      />
      <Html5TvPreview
        page={3}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
      />
      <Html5TvPreview
        page={4}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
      />
      <Html5TvPreview
        page={5}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
      />
    </>
  );
};

export default Html5Tv;
